<div class="table-container">
    <h1>JSON Request</h1>
    <br />

    <div class="col-sm-12">
        <div class="pre">
            <code>{{ data | json }}</code>
        </div>
    </div>

    <br />

    <div class="button-back-container">
        <button class="button-back" (click)="closeDialog()">Înapoi</button>
    </div>
</div>